import { makeAutoObservable } from 'mobx';

class TrainingViewModel {
  trainingProgram;
  selected = false;

  constructor(trainingProgram) {
    makeAutoObservable(this);

    this.trainingProgram = trainingProgram;
  }

  get dueDate() {
    if (this.trainingProgram.relativeDueDateValue === null) return '';

    return `${this.trainingProgram.relativeDueDateValue} ${this.trainingProgram.relativeDueDateUnit} from start date`;
  }

  get name() {
    return this.trainingProgram.name;
  }
}

export default TrainingViewModel;
